import React from "react";
import Layout from "./../components/Layout/Layout";
import PageUnderConstruction from "./../components/PageUnderConstruction";


const Home = () => {
    return (
        <Layout>
            <div>
                <h1>Home</h1>
                <p>Welcome to the home page!</p>
            </div>
            <PageUnderConstruction />
        </Layout>
    )
}

export default Home;